import { createFileRoute } from '@tanstack/react-router';
import { Hydrate } from '@tanstack/react-start';
import { idle } from '@tanstack/react-start/hydration';
import { useMemo } from 'react';
import { NoteContent } from '#/components/notes/note-content.tsx';
import { extractHeadings } from '#/components/notes/table-of-contents.utils.ts';
import Example from './example.md?raw';

export const Route = createFileRoute('/admin/example-md')({
	component: RouteComponent,
	head: () => ({
		meta: [{ title: 'Markdown gallery - SohanScript' }],
	}),
});

function RouteComponent() {
	const headings = useMemo(() => extractHeadings(Example), []);

	return (
		<div className="pb-10">
			<section className="container min-w-0">
				<Hydrate when={idle()}>
					<NoteContent content={Example} headings={headings} />
				</Hydrate>
			</section>
		</div>
	);
}
